<template>
	<div>
		<TopNav activeIndex="/" />
		<div style="display: flex;padding: 30px 20px;">
			<el-image style="width:35%; height: auto;border-radius: 10px;margin: 30px 10px 30px 0;" :src="homeimg" :lazy='true' alt='专利平台' fit="cover"></el-image>
			<div class="msg-box">
				<div class="msg-box-tle">最新公告</div>
				<div>
					<el-row class="msg-box-item" v-for="(item,index) in noticeData" :key="index">
						<el-col :span="1">
							<div class="msg-item-tag">
								<el-tag v-if="item.is_read == 1" type="success" size="small">已读</el-tag>
								<el-tag v-else type="info" size="small">未读</el-tag>
							</div>
						</el-col>
						<el-col :span="19">
							<div class="msg-item-con" @click="showNoticeDetail(item,index)">{{ item.title }}</div>
						</el-col>
						<el-col :span="4">
							<div class="msg-item-time">{{ item.createtime_text }}</div>
						</el-col>
					</el-row>
				</div>
				<!-- 详情弹窗 -->
				<el-dialog :title="selectedNotice.title" :visible.sync="detailVisible" width="50%">
					<div class="notice-detail">
						<p class="detail-item">发布时间：{{ selectedNotice.createtime_text }}</p>
						<p class="detail-item">阅读次数：{{ selectedNotice.views }} 次</p>
						<div class="detail-content" v-html="selectedNotice.maincontent">
						</div>
					</div>
				</el-dialog>
			</div>
		</div>

	</div>
</template>

<script>
	import TopNav from '../../components/TopNav.vue'
	import { get, post } from '@/utils/request';
	import newsApi from '@/api/news'

	export default {
		components: {
			TopNav
		},
		data() {
			return {
				detailVisible: false,
				selectedNotice: {},
				noticeData: [],
				homeimg:''
			}
		},
		created: function() {
			//加载新闻
			this.loadNewsList();
		},
		methods: {
			// 新闻数据
			loadNewsList(){
				newsApi.getnewslist().then(res=>{
					console.log(res)
					this.noticeData = res.data.list;
					this.homeimg = res.data.homeimg;
					
				})
			},
			// 显示公告详情
			showNoticeDetail(notice,index) {
				console.log(notice)
				this.selectedNotice = notice
				this.detailVisible = true
				// 标记为已读并增加阅读量
				if (notice.is_read == 0) {
					notice.is_read = 1;
				}
				notice.views++;
				newsApi.setnews({id:notice.id}).then(res=>{
					console.log(res)
				})
			},

			// 格式化时间（表格显示）
			formatTime(row, column, cellValue) {
				return cellValue.toLocaleDateString()
			},

			// 完整时间格式（弹窗显示）
			formatTimeFull(time) {
				return time
				return time.toLocaleString()
			}
		}
	}
</script>
<style lang="less" scoped>
	
	.msg-box {
		// width: flex;
		flex:1;
		margin: 30px auto;
		background-color: #ffffff;
		border-radius: 10px;
		padding-bottom: 18px;

		.msg-box-tle {
			text-align: left;
			height: 38px;
			padding: 0 10px;
			line-height: 38px;
			font-size: 18px;
			margin-bottom: 10px;
		}

		.msg-box-item {
			width: 98%;
			margin: 0 auto;
			line-height: 38px;
			display: flex;
			align-items: center;
			margin-bottom: 18px;
			background-color: #f5f7fa;
			border-radius: 6px;

			.msg-item-con {
				text-align: left;
				cursor: pointer;
			}

			.msg-item-tag {
				margin-left: 10px;
			}
		}

		.msg-box-item:last-child {
			margin-bottom: 0;
		}

		.notice-detail {
			line-height: 1.8;

			.detail-item {
				color: #909399;
				margin-bottom: 10px;
			}

			.detail-content {
				margin-top: 20px;
				padding: 15px;
				background: #f5f7fa;
				border-radius: 4px;
			}
		}
	}
</style>